<template>
    <div class="RevenueInputCur revenueInput">
        <input
            type="text"
            :value="value"
            @input="e => $emit('input', e.target.value)"
            @focus="() => isFocus = true"
            @blur="() => isFocus = false"
            @keydown="handleKeydown"
        />
        <span class="mask" v-if="!isFocus">{{ formattedValue }}</span>
    </div>
</template>

<script>
    export default{
        name : 'RevenueInputCur',
        props: ['value'],
        data(){
            return {
                isFocus : false,
            }
        },
        computed: {
            formattedValue () {
                return this.value ? new Intl.NumberFormat('en', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(this.value).replace('.00', '') : 0;
            }
        },
        methods: {
            handleKeydown (e) {
                if ( e.ctrlKey || e.altKey || typeof e.key !== 'string' || e.key.length !== 1 ) return;
                if ( !/[\d]/.test(e.key) ) e.preventDefault();
            }
        }
    };
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/RevenueInputCur.vue